import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../../actions/index';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '@material-ui/icons/Close';

import { _ } from '../../../functions/translator.js';
import { FilterActions } from '../../../constants/constants.js';
import { getBimElement } from '../../../functions/getter.js';

class BimElementDropdown extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            defaultValue: [],
            bimElementValues: this.getBimElements(),
        }
    }

    handleBimElementChange = (event) => {
        this.props.filterChange(FilterActions.BIM_ELEMENTS, event.target.value);
    };

    handleClose = (event) => {
        this.props.filterChange(FilterActions.BIM_ELEMENTS, this.state.defaultValue);
        this.props.closeCallback(event);
    }

    handleSelected = (bimElementsSelected) => {
        if (bimElementsSelected.length === 0) {
            return _('Todo');
        } else {
            return bimElementsSelected.join(', ');
        }
    }

    getBimElements = () => {
        const bimElements = [];
        for (const figureData of Object.values(this.props.figuresData)) {
            const description = figureData.attributes.bim_description;
            const bimElement = getBimElement(description);
            if (bimElement.length && !bimElements.includes(bimElement)) {
                bimElements.push(bimElement);
            }
        }
        return bimElements;
    }

    render() {
        const options = [];
        for (const bimElement of this.state.bimElementValues) {
            options.push(
                <MenuItem value={bimElement} key={bimElement}>
                    <Checkbox color="primary" checked={this.props.bimElements.includes(bimElement)}/>
                    {bimElement}
                </MenuItem>
            );
        }
        return(
            <div className={this.props.extraClass}>
                <p className='text'>
                    { _('Elemento BIM') }
                    <CloseIcon className='float-right cursor-pointer' data-type='bim_element' onClick={this.handleClose}/>
                </p>
                <Select
                value={this.props.bimElements}
                multiple={true}
                displayEmpty={true}
                renderValue={this.handleSelected}
                onChange={this.handleBimElementChange}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}>
                {options}
                </Select>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        bimElements : state.filters.bimElements,
        figuresData : state.projectData.figures,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BimElementDropdown);